import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Card,
  Modal,
  // CircularProgress,
} from "@mui/material";
import { Delete, Edit, Close, Add } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { axiosInstance } from "../../../utils/tokenSetCookie";
import { Banner } from "../../../types/types";
import { MaterialReactTable, MRT_ColumnDef } from "material-react-table";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const CUSTOM_UPLOAD_BASE_URL = import.meta.env.VITE_CUSTOM_UPLOAD_BASE_URL;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const EmailAppearance: React.FC = () => {
  const [imagePreview, setImagePreview] = useState<string | null>(null); // For logo preview
  const [imageId, setImageId] = useState<number | null>(null);
  const [imageDialogOpen, setImageDialogOpen] = useState(false); // For the logo edit dialog
  const [banners, setBanners] = useState<Banner[]>([]); // For banners
  const [bannerImage, setBannerImage] = useState<string | null | undefined>(null);
  const [bannerURL, setBannerURL] = useState<string>("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState<number | null>(null);
  const [isSetEditId, setIsEditId] = useState<number | null>(null);
  const [mode, setMode] = useState<"add" | "edit">("add");
  const [logoUrl, setLogoUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [dialogImage, setDialogImage] = useState<string | null>(null);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(true);
  const [isloading, setisLoading] = useState(false);
  const [isDraggingImage, setIsDraggingImage] = useState(false);
  const [isLogoDraggingImage, setIsLogoDraggingImage] = useState(false);

  const [posterError, setPosterError] = useState("");
  const [logoUploadError, setLogoUploadError] = useState("");
  const [imageFile, setImageFile] = useState<string | File>("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [bannerToDelete, setBannerToDelete] = useState<number | null>(null);

  const bannerColumns: MRT_ColumnDef<Banner>[] = [
    {
      accessorKey: "default",
      header: "Default",
      muiTableHeadCellProps: {
        sx: { width: "10%", minWidth: 100, textAlign: "left" },
      },
      muiTableBodyCellProps: {
        sx: { width: "10%", minWidth: 100, textAlign: "left" },
      },
      Cell: ({ row }) => (
        <FormControl component="fieldset">
          <RadioGroup
            value={row.original.isDefault === selectedBanner ? "selected" : ""}
            onChange={() => handleSelectBanner(row.original.id)}
          >
            <FormControlLabel value="selected" control={<Radio />} label="" />
          </RadioGroup>
        </FormControl>
      ),
      enableSorting: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "bannerUrl",
      header: "Banner",
      muiTableHeadCellProps: {
        sx: { width: "25%", minWidth: 200, textAlign: "left" },
      },
      muiTableBodyCellProps: {
        sx: { width: "25%", minWidth: 200, textAlign: "left" },
      },
      Cell: ({ row }) => (
        <img
          src={`${CUSTOM_UPLOAD_BASE_URL}${row.original.bannerUrl}`}
          alt="Banner"
          style={{ width: "100px", height: "55px", objectFit: "cover" }}
        />
      ),
    },
    {
      accessorKey: "bannerImage",
      header: "Banner URL",
      muiTableHeadCellProps: {
        sx: { width: "35%", minWidth: 250, textAlign: "left" },
      },
      muiTableBodyCellProps: {
        sx: { width: "35%", minWidth: 250, textAlign: "left" },
      },
    },
    {
      accessorKey: "actions",
      header: "Action",
      muiTableHeadCellProps: {
        sx: { width: "15%", minWidth: 150, textAlign: "left" },
      },
      muiTableBodyCellProps: {
        sx: { width: "15%", minWidth: 150, textAlign: "left" },
      },
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", justifyContent: "left", gap: 1 }}>
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEditBanner(row.original.id)}
          >
            <Edit />
          </IconButton>
          <IconButton
            color="error"
            size="small"
            onClick={() => {
              // setOpenDeleteModal(prev => !prev)
              openDeleteConfirmation(row.original.id)
            }}
          >
            <Delete />
          </IconButton>
        </Box>
      ),
      enableSorting: false,
      enableColumnFilter: false,
    },
  ];

  const { t } = useTranslation();

  const openDeleteConfirmation = (id: number) => {
    setOpenDeleteModal(true);
    setBannerToDelete(id);

  };

  const DeleteConfirmationModal = () => (
    <Modal
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-description"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden"
      }}
    >
      <Box sx={{
        bgcolor: "whitesmoke",
        borderRadius: "5px",
        width: "500px",
        outline: "none" // Remove focus outline
      }}>
        <Typography
          id="delete-modal-title"
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            p: "10px",
            borderBottom: "1px solid rgba(160, 160, 160, 0.47)"
          }}
        >
          Delete Banner
        </Typography>

        <Box sx={{ p: "20px" }}>
          <Typography
            id="delete-modal-description"
            sx={{ fontSize: "18px", mb: "20px" }}
          >
            Are you sure you want to delete this banner?
          </Typography>

          <Box sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "15px"
          }}>
            <Button
              onClick={() => {
                setOpenDeleteModal(false);
                setBannerToDelete(null);
              }}
              variant="outlined"
              color="primary"
            >
              Cancel
            </Button>
            <Button
              onClick={confirmDelete}
              variant="contained"
              color="error"
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );

  const confirmDelete = () => {
    if (bannerToDelete) {
      handleDeleteBanner(bannerToDelete);
    }
  };


  useEffect(() => {
    const defaultBanner = banners.find(banner => banner.isDefault);
    if (defaultBanner) {
      setSelectedBanner(defaultBanner.isDefault)
    }
  }, [banners])



  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([fetchLogo(), fetchBanners()]);
      } catch (error) {
        console.error("Error during fetch:", error);
      } finally {
        setLoading(false); // Once both API calls are completed, set loading to false
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs once on mount

  const fetchLogo = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}share-animation-settings/getShareMessageDetails`
      );


      if (response.status >= 200 && response.status < 300) {
        const logoPath = response.data.data.emailTemplateHeaderLogo;
        const id = response.data.data.id // Correct key inside 'data'
        setImageId(id);
        if (logoPath) {
          // Append the base URL for a full path
          const fullImageUrl = `${CUSTOM_UPLOAD_BASE_URL}${logoPath}`;
          setImagePreview(fullImageUrl);
        }
      }
    } catch (err) {
      toast.error("Failed to fetch logo.");
    }
  };

  const handleFileTrigger = async () => {
    if (!selectedFile) {
      fileInputRef.current?.click();
      return;
    }

    // Close the dialog first
    setImageDialogOpen(false);

    // Wait for dialog to visually close (helps smooth UX)
    setTimeout(async () => {
      setisLoading(true); // Show loader after dialog closes
      await handleLogoFilechange(selectedFile);
    }, 100); // Delay slightly to let dialog animation complete
  };

  const handleLogoFilechange = async (file: File) => {
    if (!file) {
      toast.error("Please select a logo file.");
      return;
    }

    const formData = new FormData();
    formData.append("logoUrl", logoUrl || file.name);
    formData.append("file", file);

    try {
      if (file.type === "image/svg+xml") {
        toast.error("Invalid file format. SVG files are not allowed.");
        setLogoUrl("");
        setSelectedFile(null);
        setDialogImage(null);
        return;
      }

      const response = await axiosInstance.post(
        `${API_BASE_URL}share-animation-settings/uploadLogo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setImagePreview(
          `${CUSTOM_UPLOAD_BASE_URL}${response.data.data.filePath}`
        );
        setLogoUrl("");
        setSelectedFile(null);
        setDialogImage(null);

        toast.success(response.data.message);

        fetchLogo();
        setImageDialogOpen(false);
      } else {
        toast.error("Failed to upload logo.");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error("An error occurred while uploading the logo.");
    } finally {
      setisLoading(false);
    }
  };

  const handleUploadLogoFilechange = async (file: File | null) => {
    const formData = new FormData();
    // formData.append("logoUrl", logoUrl || file.name);
    formData.append("file", file as File);

    try {
      // if (file?.type === "image/svg+xml") {
      //   toast.error("Invalid file format. SVG files are not allowed.");
      //   setLogoUrl("");
      //   setSelectedFile(null);
      //   setDialogImage(null);
      //   return;
      // }

      const response = await axiosInstance.post(
        `${API_BASE_URL}share-animation-settings/uploadLogo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setImagePreview(
          `${CUSTOM_UPLOAD_BASE_URL}${response.data.data.filePath}`
        );
        // setLogoUrl("");
        setSelectedFile(null);
        // setDialogImage(null);

        toast.success(response.data.message);

        fetchLogo();
        // setImageDialogOpen(false);
      } else {
        toast.error("Failed to upload logo.");
      }
    } catch (error) {
      console.error("Upload Error:", error);
      toast.error("An error occurred while uploading the logo.");
    } finally {
      setisLoading(false);
    }
  };

  const handleDeleteLogo = async () => {
    const formData = new FormData();
    // formData.append("logoUrl", logoUrl || file.name);
    formData.append("id", imageId?.toString() || "");

    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/deleteLogo`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        setImagePreview(null);
        setImageId(null)
        // setLogoUrl("");
        setSelectedFile(null);
        // setDialogImage(null);

        toast.success(response.data.message);

        fetchLogo();
      } else {
        toast.error("Failed to delete logo.");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      toast.error("An error occurred while deleting the logo.");
    } finally {
      setisLoading(false);
    }
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setSelectedFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        setDialogImage(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  // const handleResetFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   setSelectedFile(file);
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     if (typeof reader.result === "string") {
  //       setBannerURL(reader.result);
  //     }
  //   };
  //   reader.readAsDataURL(file);
  // };

  // const handleBannerFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       if (typeof reader.result === "string") {
  //         setBannerURL(reader.result);
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleCloseDialog = () => {
    setLogoUrl("");
    setDialogImage(null);
    setImageDialogOpen(false); // or however you close it

    setOpenDialog(false);
    setSelectedBanner(null);
    setMode("add");
    setBannerImage(null);
    setBannerURL("");
  };

  // Function to convert Base64 to File object
  // function base64ToFile(base64String: string) {
  //   if (!base64String || typeof base64String !== "string") {
  //     console.error("Invalid Base64 string:", base64String);
  //     return null;
  //   }

  //   const match = base64String.match(/^data:(.*?);base64,(.*)$/);
  //   if (!match) {
  //     console.error("Base64 format error:", base64String);
  //     return null;
  //   }

  //   const mime = match[1]; // Extract MIME type
  //   const base64Data = match[2]; // Extract Base64 content

  //   try {
  //     const byteCharacters = atob(base64Data);
  //     const byteNumbers = new Array(byteCharacters.length);
  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }

  //     const byteArray = new Uint8Array(byteNumbers);
  //     const fileBlob = new Blob([byteArray], { type: mime });

  //     return new File([fileBlob], `file.${mime.split("/")[1]}`, { type: mime });
  //   } catch (error) {
  //     console.error("Error decoding Base64:", error);
  //     return null;
  //   }
  // }


  const fetchBanners = async () => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}share-animation-settings/getBannerList`
      );

      if (response.status >= 200 && response.status < 300) {
        const banners = response.data.data;
        setBanners(banners);
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const errorMessage =
          err.response?.data?.message || "Failed to load banners";
        toast.error(errorMessage);
      } else {
        toast.error("An unexpected error occurred");
      }
    }
  };


  useEffect(() => {
    if (mode === "add") {
      setBannerImage("");
      setBannerURL("");
    }
  }, [mode]);

  const handleAddBanner = async () => {
    if (!bannerImage || !bannerURL) {
      toast.error("Please provide a image or URL.");
      return;
    }


    // const profileImage = base64ToFile(bannerURL); // Convert Base64 to File object
    // // Ensure we got a valid File object
    // if (!profileImage) {
    //   toast.error("Invalid image format");
    //   return;
    // }
    // Prepare FormData for API request
    const formData = new FormData();
    formData.append("bannerUrl", bannerImage ? bannerImage : "");
    formData.append("file", imageFile);
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}share-animation-settings/addBannerSetting`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Ensure this header
          },
        }
      );

      if (response.status >= 200 && response.status <= 300) {
        setBannerImage(bannerImage);
        setBannerURL(bannerURL);
        setOpenDialog(false);
        setSelectedBanner(null);
        fetchBanners();
      }
      toast.success(response.data.message);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message || "Failed to upload banner";
        toast.error(errorMessage);
      } else {
        toast.error("An error occurred");
      }
    }
  };

  const handleUpdateBanner = async () => {
    // if (!selectedBanner) {
    //   toast.error("Please select a banner to update.");
    //   return;
    // }

    if (!bannerImage && !bannerURL) {
      toast.error(
        "Please provide either a new image or a banner URL to update."
      );
      return;
    }
    const formData = new FormData();
    formData.append("id", isSetEditId?.toString() || ""
    ); //id

    // Append only the updated fields
    if (bannerImage) {
      formData.append("bannerUrl", bannerImage); //name
    }
    
      // const profileImage = base64ToFile(bannerURL);
      if (bannerURL) {
        formData.append("file", imageFile); //image file
      } else {
        toast.error("Invalid image format");
        return;
      }
    
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/updateBannerSetting`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status >= 200 && response.status < 300) {
        toast.success("Banner updated successfully!");
        // Fetch fresh banner data to prevent incorrect state updates
        fetchBanners();

        setOpenDialog(false);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorMessage =
          error.response?.data?.message || "Failed to update banner";
        toast.error(errorMessage);
      } else {
        toast.error("An error occurred");
      }
    }
  };

  const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];
  const MAX_IMAGE_SIZE_MB = 5;
  // const isDisabled = uploadedFile.poster !== "" || uploadedFile.fileName === "";

  const validateImage = (file: File): Promise<boolean> => {
    return new Promise((resolve) => {
      if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        setPosterError("Only JPEG, PNG, WEBP, and GIF formats are allowed.");
        return resolve(false);
      }

      if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
        setPosterError("Image is too large. Please upload a file under 5MB.");
        return resolve(false);
      }

      // Optional: you can check image dimensions here if needed
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => {
        setPosterError("Invalid image file.");
        resolve(false);
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const handleImageDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDraggingImage(false);

    const file = e.dataTransfer.files?.[0];
    if (!file) {
      setPosterError("No file dropped.");
      return;
    }

    setPosterError("");

    const isValid = await validateImage(file);
    if (isValid) {
      const imageURL = URL.createObjectURL(file);
      setImageFile(file)
      setBannerURL(imageURL)

      // setUploadedFile({
      //   ...uploadedFile,
      //   poster: imageURL,
      // });
      // setUploadData({ ...uploadData, thumbImage: file })
      // setPoster(imageURL);
    }
  };

  const handleUploadImageDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDraggingImage(false);

    const file = e.dataTransfer.files?.[0];
    if (!file) {
      setLogoUploadError("No file dropped.");
      return;
    }

    setLogoUploadError("");

    const isValid = await validateImage(file);
    if (isValid) {
      const imageURL = URL.createObjectURL(file);
      setSelectedFile(file)
      setDialogImage(imageURL)

      // setUploadedFile({
      //   ...uploadedFile,
      //   poster: imageURL,
      // });
      // setUploadData({ ...uploadData, thumbImage: file })
      // setPoster(imageURL);
    }
  };

  const handleLogoImageDrop = async (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsLogoDraggingImage(false);

    const file = e.dataTransfer.files?.[0];
    if (!file) {
      setLogoUploadError("No file dropped.");
      return;
    }

    setLogoUploadError("");

    const isValid = await validateImage(file);
    if (isValid) {
      const imageURL = URL.createObjectURL(file);

      // setSelectedFile(file)
      await handleUploadLogoFilechange(file);
      // setDialogImage(imageURL)
      setImagePreview(imageURL);
    }
  };



  const handleDeleteBanner = async (bannerId: string | number) => {
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/deleteBanner`,
        { id: bannerId }
      );

      if (response.status >= 200 && response.status <= 300) {
        setOpenDeleteModal(false); // Close modal
        setBanners((prev) => prev.filter((banner) => banner.id !== bannerId));
        const message = typeof response.data === "string"
          ? response.data
          : "Banner deleted successfully";
        toast.success(message);
      } else {
        toast.error("Failed to delete banner.");
      }
    } catch (error) {
      console.error("Error deleting banner:", error);
      toast.error("An error occurred while deleting the banner.");
    }

  };

  const handleEditBanner = (id: string | number) => {
    if (!id) return;
    setIsEditId(id as number)
    // Convert bannerId to number if it's a string
    const numericBannerId =
      typeof id === "string" ? parseInt(id, 10) : id;
    // Find the banner from the list
    const selectedBannerData = banners.find(
      (banner) => banner.id === numericBannerId
    );
    if (!selectedBannerData) {
      toast.error("Banner not found!");
      return;
    }
    setBannerURL(selectedBannerData.bannerUrl);
    setBannerImage(selectedBannerData.bannerImage);
    // Pre-fill state with existing banner details
    setMode("edit");
    // setSelectedBanner(false); //Reseted from number to boolean

    setOpenDialog(true);
  };

  const handleSelectBanner = async (id: number) => {
    let parms = { id: id };
    try {
      const response = await axiosInstance.put(
        `${API_BASE_URL}share-animation-settings/bannerIsDefaultChecked`,
        parms
      );

      if (response.status >= 200 && response.status < 300) {
        setSelectedBanner(response.data.data.isDefault);
      }
    } catch (err) {
      // console.error("Fetch Email Error:", err);
      toast.error("Failed to fetch email details.");
    }
  };


  const handleFileSelect = async (
    e: any
  ) => {
    e.preventDefault();

    // Clean up previous URL to prevent memory leaks
    if (bannerURL && bannerURL.startsWith('blob:')) {
      URL.revokeObjectURL(bannerURL);
    }

    let file: File | undefined;

    // Handle both drag and file input events
    if ('dataTransfer' in e) {
      file = e.dataTransfer.files?.[0];
    } else {
      file = e.target.files?.[0];
    }

    if (!file) {
      setPosterError("No files were selected.");
      return;
    }

    // Check file type before processing
    if (!file.type.startsWith('image/')) {
      setPosterError("Please select an image file.");
      return;
    }

    setPosterError("");

    try {
      const isValid = await validateImage(file);
      if (isValid) {
        const imageURL = URL.createObjectURL(file);
        setImageFile(file);
        setBannerURL(imageURL);
      } else {
        setPosterError("Invalid image file or file doesn't meet requirements.");
      }
    } catch (error) {
      console.error("Image validation error:", error);
      setPosterError("Error processing image file.");
    }

    e.target.value = '';
  };

  useEffect(() => {
    if (selectedBanner) {
      // Assuming selectedBanner has the image path
      const selected = banners.find((b) => b.isDefault);
      if (selected) {
        setBannerImage(selected.bannerImage); // if you're using this field in form
        setBannerURL(`${CUSTOM_UPLOAD_BASE_URL}${selected.bannerUrl}`);
      }
    } else {
      // Reset if adding a new banner
      setBannerImage("");
      setBannerURL("");
    }
  }, [selectedBanner]);
  return (
    <div>

      <DeleteConfirmationModal />

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            transform: "scale(1.4)",
            zIndex: 9999,
            backgroundImage: `url(${VISUALIZE__URL}+"link.mp4")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "50px 50px", // Set image size to 50px width and height
            backgroundColor: "#fff",
            opacity: 0.5,
          }}
        />
      ) : (
        <Box sx={{ p: 1, backgroundColor: "#ffffff", borderRadius: "12px" }}>
          {isloading && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                transform: "scale(1.4)",
                zIndex: 9999,
                backgroundImage: `url(${VISUALIZE__URL}+"link.mp4")`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50px 50px", // Set image size to 50px width and height
                backgroundColor: "#fff",
                opacity: 0.5,
              }}
            />
          )}

          <Box sx={{
            display: "flex",
            gap: 2,
            // height: "700px"
          }}>
            {/* Logo Section */}
            <Card
              elevation={0}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                p: 3,
                mb: 4,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              }}
            >

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "primary.main",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img
                    src={imagePreview ? imagePreview : ""}
                    alt=""
                    style={{ width: 24, height: 24 }}
                  />
                  {t("your_logo")}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                {/* Logo Preview Box */}
                <Box
                  sx={{
                    width: 200,
                    height: 200,
                    borderRadius: "12px",
                    border: isLogoDraggingImage ? "2px dashed #2196f3" : "2px dashed rgba(0,0,0,0.12)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    backgroundColor: "#f8f9fa",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    // "&:hover": {
                    //   borderColor: "primary.main",
                    //   transform: "translateY(-2px)",
                    //   boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    // },
                    "&:hover .action-buttons": {
                      opacity: 1,
                      visibility: "visible",
                    },
                  }}
                >

                  {imagePreview !== null ? (
                    <img
                      src={imagePreview}
                      alt="Logo Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        padding: "16px",
                      }}
                    />
                  ) : (
                    <Box>
                      <Box
                        onDragOver={(e) => {
                          // if (isDisabled) return;
                          e.preventDefault();
                        }}
                        onDragEnter={() => setIsLogoDraggingImage(true)}
                        onDragLeave={() => setIsLogoDraggingImage(false)}
                        onDrop={(e) => {
                          handleLogoImageDrop(e);
                        }}
                        style={{
                          // border: isDraggingImage ? "2px dashed #2196f3" : "2px dashed #ccc",
                          padding: "20px",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                      >
                        {isLogoDraggingImage ? (
                          <Typography>Drop here</Typography>

                        ) : (
                          <Typography>Drag and drop your logo here</Typography>

                        )}
                      </Box>
                      {logoUploadError && (
                        <Typography sx={{ mt: 1, color: "red", fontSize: "14px", textAlign: "center" }}>
                          {logoUploadError}
                        </Typography>
                      )}
                    </Box>

                  )}


                  {imagePreview && (
                    <Box
                      className="action-buttons"
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        display: "flex",
                        gap: 1,
                        padding: "4px",
                        borderRadius: "8px",
                        opacity: 0,
                        visibility: "hidden",
                        transition: "opacity 0.3s ease",
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => setImageDialogOpen(true)}
                        sx={{
                          backgroundColor: "primary.main",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "primary.dark",
                          },
                        }}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={handleDeleteLogo}
                        sx={{
                          backgroundColor: "error.main",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "error.dark",
                          },
                        }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>

                {/* Upload Instructions */}
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1" gutterBottom>
                    {t("logo_requirements")}:
                  </Typography>
                  <ul style={{ color: "text.secondary", paddingLeft: "20px" }}>
                    <li>Maximum file size: 2MB</li>
                    <li>Recommended dimensions: 200x200px</li>
                    <li>Transparent background preferred</li>
                    <li>
                      Allowed only jpg,jpeg,png,webp,gif,mp3,wav,ogg,mp4,webm
                    </li>
                  </ul>
                  <Button
                    variant="contained"
                    onClick={() => setImageDialogOpen(true)}
                    sx={{
                      // mt: 2,
                      borderRadius: "10px",
                      textTransform: "none",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    {t("upload_logo")}
                  </Button>
                </Box>
              </Box>
            </Card>

            {/* Banner Section */}
            <Card
              elevation={0}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                width: "100%",
                p: 3,
                boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "primary.main",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img
                    src={imagePreview ? imagePreview : ""}
                    alt=""
                    style={{ width: 24, height: 24 }}
                  />
                  {t("your_banner")}
                </Typography>

                <Button
                  variant="contained"
                  onClick={() => {
                    setMode("add");
                    // setSelectedBanner(false);
                    setBannerImage(null);
                    setBannerURL("");
                    setOpenDialog(true);
                  }}
                  startIcon={<Add />}
                  sx={{
                    borderRadius: "10px",
                    textTransform: "none",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  {t("add_banner")}
                </Button>
              </Box>

              {/* Banner Table */}
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  height: "530px",
                  overflowY: "auto",
                  "&::-webkit-scrollbar": {
                    width: "5px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    borderRadius: "4px",
                  },
                }
                }
              >
                <MaterialReactTable
                  columns={bannerColumns}
                  data={banners}
                  enableDensityToggle={false}
                  enableColumnResizing={false}
                  enableHiding={false}
                  enableGlobalFilter={false}
                  enableFilters={false}
                  enableFullScreenToggle={false}
                  initialState={{ pagination: { pageSize: 5, pageIndex: 0 } }}
                  muiTablePaperProps={{
                    elevation: 0,
                    sx: { backgroundColor: "transparent" },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      backgroundColor: "#f8f9fa",
                      fontWeight: 600,
                      color: "text.primary",
                    },
                  }}
                  muiTableBodyRowProps={{
                    sx: {
                      "&:nth-of-type(odd)": {
                        backgroundColor: "#fff",
                      },
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f8f9fa",
                      },
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                      transition: "background-color 0.2s ease",
                    },
                  }}
                />
              </Box>
            </Card>
          </Box>


          {/* Logo Upload Dialog */}
          <Dialog
            open={imageDialogOpen}
            onClose={() => setImageDialogOpen(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: "16px",
                overflow: "hidden",
              },
            }}
          >
            <DialogTitle
              sx={{
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                p: 3,
              }}
            >
              <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                {t("upload_logo")}
              </Typography>
              <IconButton
                onClick={handleCloseDialog}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 12,
                  border: "1px solid",
                  borderColor: "error.main",
                  color: "error.main",
                  "&:hover": {
                    backgroundColor: "error.main",
                    color: "white",
                  },
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            {/* <DialogContent>
              <Box
                sx={{
                  padding: 3,
                  borderRadius: "12px",
                  textAlign: "center",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <TextField
                  label={t("logo_url")}
                  fullWidth
                  value={logoUrl}
                  onChange={(e) => setLogoUrl(e.target.value)}
                  sx={{ mb: 3 }}
                />
                <Box
                  onClick={() => fileInputRef.current?.click()}
                  sx={{
                    border: "2px dashed rgba(0,0,0,0.12)",
                    borderRadius: "12px",
                    p: 4,
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      borderColor: "primary.main",
                      backgroundColor: "#f5f7fa",
                    },
                  }}
                >
                  {!dialogImage ? (
                    <Box>
                      <Typography>
                        {t("drag_and_drop_your_logo_here")}
                      </Typography>
                      <Typography
                        variant="caption"
                        display="block"
                        color="text.secondary"
                        mb={2}
                      >
                        {t("or")}
                      </Typography>
                      <Button
                        variant="outlined"
                        component="label"
                        sx={{ borderRadius: "8px" }}
                      >
                        {t("browse_files")}
                      </Button>
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange} //select image
                      />
                    </Box>
                  ) : (
                    <Box>
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          height: 300,
                          bgcolor: "transparent",
                          mt: 2,
                          mb: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          component="img"
                          src={dialogImage}
                          alt="Logo Preview"
                          sx={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>
                {dialogImage && (
                  <Box display="flex" justifyContent="center" gap={2}>
                    <Button
                      variant="contained"
                      component="label"
                      color="primary"
                      sx={{ textTransform: "none", mt: 2 }}
                    >
                      {t("reset")}
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange} // reset the selected image
                      />
                    </Button>
                  </Box>
                )}
              </Box>
            </DialogContent> */}

            <DialogContent>
              <Box
                sx={{
                  padding: 3,
                  borderRadius: "12px",
                  textAlign: "center",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <TextField
                  label={t("logo_url")}
                  fullWidth
                  value={logoUrl}
                  onChange={(e) => setLogoUrl(e.target.value)}
                  sx={{ mb: 3 }}
                />

                <Box
                  onClick={() => fileInputRef.current?.click()}
                  sx={{
                    border: isDraggingImage ? "2px dashed #2196f3" : "2px dashed #ccc",
                    borderRadius: "12px",
                    p: 4,
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                    transition: "all 0.3s ease",
                  }}
                >
                  <Box
                    onDragOver={(e) => e.preventDefault()}
                    onDragEnter={() => setIsDraggingImage(true)}
                    onDragLeave={() => setIsDraggingImage(false)}
                    onDrop={(e) => handleUploadImageDrop(e)}
                    style={{
                      padding: "20px",
                      textAlign: "center",
                      display: dialogImage ? "none" : "block",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="file"
                      hidden
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <label htmlFor="img-upload-input" style={{ cursor: "pointer", textAlign: "center" }}>
                      <Typography sx={{ mt: 1, pointerEvents: "none" }}>
                        {isDraggingImage
                          ? t("drop_your_logo_here")
                          : t("drag_and_drop_your_logo_here")}
                      </Typography>
                      <Typography>({t("or")})</Typography>
                      <Typography
                        sx={{
                          mt: 1,
                          backgroundColor: "primary.main",
                          py: "8px",
                          px: "8px",
                          borderRadius: "4px",
                          color: "white",
                          display: "inline-block",
                        }}
                      >
                        {t("click_to_upload")}
                      </Typography>
                    </label>
                  </Box>

                  {logoUploadError && (
                    <Typography sx={{ mt: 1, color: "red", fontSize: "14px" }}>
                      {logoUploadError}
                    </Typography>
                  )}

                  {dialogImage && (
                    <Box>
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          height: 300,
                          bgcolor: "transparent",
                          mt: 2,
                          mb: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          component="img"
                          src={dialogImage}
                          alt="Logo Preview"
                          sx={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                </Box>

                {dialogImage && (
                  <Box display="flex" justifyContent="center" gap={2}>
                    <Button
                      variant="contained"
                      component="label"
                      color="primary"
                      sx={{ textTransform: "none", mt: 2 }}
                    >
                      {t("reset")}
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </Button>
                  </Box>
                )}
              </Box>
            </DialogContent>


            <DialogActions sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
              <Button
                onClick={() => handleCloseDialog()}
                variant="outlined"
                sx={{ borderRadius: "8px", textTransform: "none" }}
              >
                {t("cancel")}
              </Button>

              <Button
                onClick={handleFileTrigger}
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                {t("upload")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Banner Dialog */}
          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            maxWidth="md"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: "16px",
                overflow: "hidden",
              },
            }}
          >
            <DialogTitle
              sx={{
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                p: 3,
              }}
            >
              <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                {mode === "edit" ? "Edit Banner" : "Add Banner"}
              </Typography>
              <IconButton
                onClick={() => {
                  setOpenDialog(false)
                  setPosterError("")
                  setSelectedFile(null)
                }}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: 12,
                  border: "1px solid",
                  borderColor: "error.main",
                  color: "error.main",
                  "&:hover": {
                    backgroundColor: "error.main",
                    color: "white",
                  },
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>

            <DialogContent>
              <Box
                sx={{
                  padding: 3,
                  borderRadius: "12px",
                  textAlign: "center",
                  backgroundColor: "#f8f9fa",

                }}
              >
                <TextField
                  label="Banner URL"
                  fullWidth
                  value={bannerImage}
                  onChange={(e) => setBannerImage(e.target.value)}
                  sx={{
                    mb: 3
                  }}
                />
                <Box
                  onClick={() => fileInputRef.current?.click()}
                  sx={{
                    border: isDraggingImage ? "2px dashed #2196f3" : "2px dashed #ccc",

                    // border: "2px dashed rgba(0,0,0,0.12)",
                    position: "relative",
                    borderRadius: "12px",
                    p: 4,
                    textAlign: "center",
                    backgroundColor: "#f8f9fa",
                    transition: "all 0.3s ease",

                    // "&:hover": {
                    //   borderColor: "primary.main",
                    //   backgroundColor: "#f5f7fa",
                    // },
                  }}
                >


                  <Box
                    onDragOver={(e) => {
                      // if (isDisabled) return;
                      e.preventDefault();
                    }}
                    onDragEnter={() => setIsDraggingImage(true)}
                    onDragLeave={() => setIsDraggingImage(false)}
                    onDrop={(e) => {
                      handleImageDrop(e);
                    }}
                    style={{
                      // border: isDraggingImage ? "2px dashed #2196f3" : "2px dashed #ccc",
                      padding: "20px",
                      textAlign: "center",
                      display: bannerURL ? "none" : "block",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="file"
                      // ref={fileInputRef}
                      accept="image/*"
                      style={{ display: "none" }}
                      id="img-upload-input"
                      onChange={handleFileSelect}
                    />
                    <label htmlFor="img-upload-input" style={{ cursor: "pointer", textAlign: "center" }}>
                      <Typography sx={{ mt: 1, pointerEvents: "none" }}>
                        {isDraggingImage
                          ? "Drop your image here"

                          : "Drag and drop an image file here"}
                      </Typography>
                      <Typography>(or)</Typography>
                      <Typography
                        sx={{
                          mt: 1,
                          backgroundColor: "primary.main",
                          py: "8px",
                          px: "8px",
                          display: "inline-block",
                          borderRadius: "4px",
                          color: "white",
                        }}
                      >
                        Click to upload
                      </Typography>
                    </label>
                  </Box>

                  {posterError && (
                    <Typography sx={{ mt: 1, color: "red", fontSize: "14px" }}>
                      {posterError}
                    </Typography>
                  )}


                  {bannerURL && <Box>
                    <Box
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: 300,
                        bgcolor: "transparent",
                        mt: 2,
                        mb: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src={`${bannerURL.startsWith("h") || bannerURL.startsWith("b") ? bannerURL : `${CUSTOM_UPLOAD_BASE_URL}${bannerURL}`}`}
                        alt="Banner Preview"
                        sx={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  </Box>}


                </Box>
              </Box>
            </DialogContent>
            {bannerURL && (
              <Box display="flex" justifyContent="center" gap={2}>
                <Button
                  variant="contained"
                  component="label"
                  color="primary"
                  sx={{ textTransform: "none", mt: 2 }}
                >
                  {t("reset")}
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleFileSelect}
                  />
                </Button>
              </Box>
            )}
            <DialogActions sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
              <Button
                onClick={() => setOpenDialog(false)}
                variant="outlined"
                sx={{ borderRadius: "8px", textTransform: "none" }}
              >
                {t("cancel")}
              </Button>
              <Button
                onClick={() => {
                  if (mode === "edit") {
                    handleUpdateBanner();
                  } else {
                    handleAddBanner();
                  }
                }}
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  textTransform: "none",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                {mode === "edit" ? "Update Banner" : "Add Banner"}
              </Button>
            </DialogActions>
          </Dialog>
        </Box >
      )}
    </div >
  );
};

export default EmailAppearance;
